import { ReactNode } from "react";
import { useInView } from "react-intersection-observer";

interface LazyScrollProps {
  children: ReactNode;
  height?: string | number; // Optional height for placeholder
  className?: string; // Optional className for wrapper
}

/**
 * LazyScroll component for lazy loading content when it comes into viewport
 *
 * Uses react-intersection-observer to detect when element enters viewport
 * and only renders children at that point to improve performance
 *
 * @param children - Content to be lazily rendered
 * @param height - Optional height for placeholder div to prevent layout shifts
 * @param className - Optional className to style wrapper div
 */

function LazyScroll({
  children,
  height = "400px",
  className = "",
}: LazyScrollProps) {
  const { ref, inView } = useInView({
    rootMargin: "300px",
    triggerOnce: true,
  });

  return (
    <div ref={ref} className={className}>
      {inView ? (
        children
      ) : (
        // Placeholder div to prevent layout shifts
        <div style={{ height }} />
      )}
    </div>
  );
}

export default LazyScroll;
